export default "__VITE_ASSET__CWQbKpIX__";